var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-item-content file-email"},[_c('div',{staticClass:"file-name"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"file-bg",on:{"click":_vm.viewFile}},[_c('div',{staticClass:"file-content"},[_c('a',{staticClass:"file-name-link",attrs:{"href":'mailto:'+`${_vm.content}`}},[_vm._v(_vm._s(_vm.content))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }